import type { SilentCronXConfig, SilentCronXLogger } from "../types/config.js";

const noop = () => undefined;

export function createLogger(config: SilentCronXConfig): Required<SilentCronXLogger> {
  const base = config.logger ?? {};
  return {
    info: base.info ?? noop,
    warn: base.warn ?? noop,
    error: base.error ?? noop,
    debug: config.debug ? base.debug ?? noop : noop,
  };
}
